import apiCall from '../../apiCall/apiCall';
import buildUrlSearchParams from '../../apiCall/buildUrlSearchParams/buildUrlSearchParams';
// This class handles any API calls related to goods-in-type vehicles.
class GoodsOut {
  static all(params) {
    const data = buildUrlSearchParams(params);
    return apiCall('GET', 'api/warehouses/goods_out', data);
  }

  static show(category, id) {
    const data = buildUrlSearchParams({ category: category });
    return apiCall('GET', `api/warehouses/goods_out/${id}`, data);
  }

  static start(category, id) {
    const data = { category: category };
    return apiCall('POST', `api/warehouses/goods_out/${id}/start`, data);
  }

  static cancel(category, id) {
    const data = { category: category };
    return apiCall('POST', `api/warehouses/goods_out/${id}/cancel`, data);
  }

  static confirm(category, id, name, signature, reasons) {
    const data = { category: category, name: name, signature: signature, reasons: reasons };
    return apiCall('POST', `api/warehouses/goods_out/${id}/confirm`, data);
  }

  static unconfirm(category, id) {
    const data = { category: category };
    return apiCall('POST', `api/warehouses/goods_out/${id}/unconfirm`, data);
  }

  static updateExpectedArrivalTime(category, id, expectedDate, expectedHour) {
    const data = {
      category: category,
      expectedDate: expectedDate,
      expectedHour: expectedHour,
    };

    return apiCall('POST', `api/warehouses/goods_out/${id}/update_arrival_time`, data);
  }

  static updateArrivalTime(category, actual, id) {
    const data = { category: category, actual: actual };
    return apiCall('POST', `api/warehouses/goods_out/${id}/update_arrival_time`, data);
  }

  static assign(category, id, packageIds) {
    const params = { category: category, packageIds: packageIds };
    return apiCall('POST', `api/warehouses/goods_out/${id}/assign`, params);
  }

  static remove(category, id, packageIds) {
    const params = { category: category, packageIds: packageIds };
    return apiCall('POST', `api/warehouses/goods_out/${id}/remove`, params);
  }

  static transship(id, params) {
    return apiCall('POST', `api/warehouses/goods_out/${id}/transship`, params);
  }

  static updateDefaultBay(category, bay, id) {
    const data = { category: category, bayId: bay };
    return apiCall('POST', `api/warehouses/goods_out/${id}/update_default_bay`, data);
  }
}

export default GoodsOut;
